import type { ReactNode } from 'react';

import DismissIcon from 'apps/kiosk/assets/svg/dismiss';

import { ModalBackground, CloseButton, CloseButtonContent } from './Modals.styled';
import { SlideUpModalBox, SlideUpModalContent } from './SlideUpModal.styled';

import type { BoxProps } from '@m/components/uikit';
import type { StyledSystemProps } from '@m/theme/helpers/withStyledSystem';

interface SlideUpModalProps extends BoxProps {
  boxProps?: StyledSystemProps;
  children?: ReactNode;
  hideCloseButton?: boolean;
  onCancel?: () => void;
  show?: boolean;
  variant?: 'sheet' | 'overlay';
}

export function SlideUpModal({
  show = false,
  variant = 'sheet',
  onCancel = () => {},
  hideCloseButton,
  boxProps,
  children,
  ...contentProps
}: SlideUpModalProps) {
  return (
    <SlideUpModalBox {...boxProps} show={show} variant={variant}>
      <ModalBackground onClick={onCancel} />
      <SlideUpModalContent {...contentProps} show={show} variant={variant}>
        {children}
        <CloseButton onClick={onCancel} hide={hideCloseButton}>
          <CloseButtonContent>
            <DismissIcon />
          </CloseButtonContent>
        </CloseButton>
      </SlideUpModalContent>
    </SlideUpModalBox>
  );
}
